import generic from './svg/generic/generic.js';
import mcb from './svg/mcb/mcb.js';
import volt from './svg/volt/volt.js';
import rcd from './svg/rcd/rcd.js';
import mcb_wide from './svg/mcb-wide/mcb-wide.js';
import rcd2 from './svg/rcd2/rcd2.js';
import rcd3 from './svg/rcd3/rcd3.js';
import rcd4 from './svg/rcd4/rcd4.js';
import socket from './svg/socket/socket.js';
import switcher from './svg/switcher/switcher.js';
import space from './html/space/space.js';
import bus from './svg/bus/bus.js';
import input from './svg/input/input.js';
import connector from './svg/connector/connector.js';
let deviceSVG = {};
deviceSVG['generic'] = generic;
deviceSVG['mcb-wide'] = mcb_wide;
deviceSVG['mcb'] = mcb;
deviceSVG['volt'] = volt
deviceSVG['rcd'] = rcd
deviceSVG['rcd2'] = rcd2
deviceSVG['rcd3'] = rcd3
deviceSVG['rcd4'] = rcd4
deviceSVG['socket'] = socket
deviceSVG['switcher'] = switcher
deviceSVG['space'] = space
deviceSVG['bus'] = bus
deviceSVG['connector'] = connector
deviceSVG['input'] = input
deviceSVG['empty'] = generic // backward compatibility
deviceSVG['terminal'] = generic // backward compatibility
export default class {
    constructor() {

    }
    getWidth = (widthInMM) => {
        // if (version === 'small') {
        //     return widthInMM * PX_IN_MM + 'px'
        // }
        // return widthInMM + widthInMM / 17.5 + 'mm';
        return widthInMM
    }

    render_device(device, scale, skipMenu = false) {
        // return
        // console.log(device);

        if (typeof deviceSVG[device.type] === 'undefined') {
            console.error(`SVG rendere not found for type ${device.type}`)
            return;
        }
        let deviceHtml = deviceSVG[device.type].render(device, scale)
        if (!deviceHtml && !skipMenu) {

            device.type = 'generic'
            deviceHtml = deviceSVG['generic'].render(device, scale);
            STORAGE.updateDevice(device);
        }

        if (deviceHtml) {
            return `<div data-type="${device.type}" data-id=${device.id} data-position="${device.position}" data-width="${device.width}" data-rail=${device.rail} data-text-id="${device.textId ? device.textId : ''}" class="device standard"  ${skipMenu ? "" : 'data-menu="device"'}>
           ${deviceHtml}
           ${this.render_danger(device.id, scale)}
            </div>`
        }
    }
    render_id(textId) {
        return `<div class='deviceId'>${textId}</div>`
    }

    render_bus(bus, scale, noPosition = false) {
        const busHtml = deviceSVG['bus'].render(bus, scale);
        if (busHtml) {
            const twisted = bus.twisted == true
            const zIndex = (bus.zIndex ? bus.zIndex : 0) + 1000
            const width = bus.width ? bus.width : 0
            return `<div data-type="bus" data-id=${bus.id} data-width="${width}" class="device bus" data-menu="bus" style="${twisted ? `transform:rotate(-90deg);` : ""} z-index:${zIndex}; ">
            ${busHtml}            
            ${this.render_danger(bus.id, scale, twisted ? 90 : 0, bus.out)}
            </div>`
        }
    }

    render_connector(connector, scale, noPosition = false) {
        const connectorHtml = deviceSVG['connector'].render(connector, scale);
        if (connectorHtml) {
            const twisted = connector.twisted == true
            const zIndex = (connector.zIndex ? connector.zIndex : 0)
            const width = connector.width ? connector.width : 0


            return `<div data-type="connector" data-id=${connector.id} data-width="${width}" class="device connector" data-menu="connector" style="${twisted ? `transform:rotate(-180deg);` : ""} z-index:${zIndex}">
            ${connectorHtml}
            
            </div>`
        }
    }

    render_input(input, scale, noPosition = false) {
        const inputHtml = deviceSVG['input'].render(input, scale);
        const twisted = input.twistedDeg == true


        if (inputHtml) {
            const zIndex = (input.zIndex ? input.zIndex : 0)
            const width = input.width ? input.width : 0

            return `<div data-type="input" data-id=${input.id} data-width="${width}" class="device input" data-menu="input" style="${input.twistedDeg ? `transform:rotate(${input.twistedDeg}deg);` : ""} z-index:${zIndex}">
            ${inputHtml}
            ${this.render_danger(input.id, scale, twisted ? 90 : 0, input.out)}            
            </div>`
        }
    }

    render_sticker = (device, config) => {

        if (!device.icon) {
            device.icon = [];
        }
        if (!Array.isArray(device.icon)) { // for old schema, where we had just one image
            device.icon = device.icon.split(",")
        }

        const blackSticker = config.stickerColor === '#' + globalThis.COLORS_RGB.black;
        const icons = device.icon ? this.getIcons(device.icon, blackSticker) : ''
        const width = this.getWidth(device.width)
        const empty = device.icon?.length +
            device.color?.length +
            device.text?.length +
            device.number?.length +
            ((device.numberBottom !== 'undefined' && device.numberBottom?.length) ? 1 : 0) === 0;

        const bgColor = config.stickerColor.length ? `background-color: ${config.stickerColor} !important;` : ''


        const height = config.stickerHeight;
        const scale = config.scale;
        const marginBottom = `margin-bottom: -${parseInt(height - height / scale) || 0}mm;`
        const transform = (scale && scale != 1) ? `transform: scale(${1 / scale});` : ''

        let content = []
        let context = `<div class="sticker" data-menu="device" data-id="${device.id}" data-height=${config.stickerHeight} data-width=${width} data-deviceHeight="${SIZE.baseHeightInMm * device.height / 100 || SIZE.baseHeightInMm}" style="${bgColor}  max-height: ${config.stickerHeight}mm !important; height: ${config.stickerHeight}mm; min-width:${width}mm; width: ${width}mm; ${transform} ${marginBottom}" ${empty ? 'data-empty' : ''}>`

        const font = this.getFont(config)
        if (config.stickerNumberTop) {
            const [style, textStyle] = this.getColorsStyle(device.color);
            content.push(`<div class="nt color ${font}" style="${style}"><span class="numberContent" ${textStyle}>${device.numberTop ? device.numberTop.replaceAll("\n", "<br>") : "&nbsp;"}</span></div>`)
        }

        if (config.stickerIcon) {
            const iconHeight = 32.5 / (100 / config.iconsScale);
            content.push(`<div class="iconSticker" style="max-height:${iconHeight}px">${icons}</span></div>`)
        }

        if (config.stickerText) {
            let verticalStyle = ''
            let alignStyle = ''
            // Strict check: non-empty strings like "false" must not enable vertical mode
            const isVertical = config.stickerVerticalText === true || config.stickerVerticalText === 'true';
            if (isVertical) {
                verticalStyle = 'writing-mode: vertical-rl; transform: rotate(180deg); align-items: center;'
                // вертикальный текст: положение по горизонтали задаётся align-items (поперечная ось),
                // rotate(180deg) меняет лево/право местами, поэтому значения инвертированы
                if (config.stickerTextAlign === 'left') {
                    alignStyle = 'align-items: flex-end;'
                } else if (config.stickerTextAlign === 'right') {
                    alignStyle = 'align-items: flex-start;'
                }
            } else {
                // Explicit horizontal mode — otherwise narrow stickers wrap one letter per line
                // and look as if "Текст вертикально" were on
                verticalStyle = 'writing-mode: horizontal-tb; transform: none;'
                if (config.stickerTextAlign === 'left') {
                    alignStyle = 'text-align: left; justify-content: flex-start;'
                } else if (config.stickerTextAlign === 'right') {
                    alignStyle = 'text-align: right; justify-content: flex-end;'
                }
            }
            content.push(`<div class="text ${font} ${blackSticker ? "black" : ""} ${isVertical ? "vertical" : ""}" style="font-size:${1 * parseInt(config.fontSize) / 10}em; ${verticalStyle}${alignStyle}">${device.text?.replaceAll("\n", "<br>")}</div>`)
        }


        if (config.stickerNumberBottom) {
            const [style, textStyle] = this.getColorsStyle(device.color, true);
            content.push(`<div class="nb color ${font}" style="${style}"><span class="numberContent" ${textStyle}>${device.numberBottom?.length ? device.numberBottom.replaceAll("\n", "<br>") : "&nbsp;"}</span></div>`)
        }

        if (config.stickerInvert) {
            content = content.reverse();
        }

        context += content.join("");

        context += `</div>`
        return {
            context: context
        }
    }

    getFont = (config) => {
        return config.fontFamily ? config.fontFamily : 'font1'
    }

    isSafari = () => {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    getIcons = (icons, blackSticker = false) => {
        // return ""
        // if (this.isSafari()) {
    //     return icons.map(icon => `<img src="/images.73/icons/png/${icon}.png"/> `).join("")
        // }

        const res = icons.map(icon => ICONS[`${icon}`]).filter(Boolean).join("")
        if (blackSticker) {
            return res.replace(/#000/g, '#f2f2f2')
        }
        return res;


        // .replace(/#000/g, '#f2f2f2')


    }

    getColorsStyle = (color, bottom = false) => {
        if (!color) {
            color = [];
        }
        if (!Array.isArray(color) && color) { // for old schema, where we had just one image
            color = color.split(",")
        }

        let colors = color.filter(c => bottom ? c.includes('_bottom') : !c.includes('_bottom'))
        colors = colors.map(color => color.replace("_bottom", ""))

        let style = "background: linear-gradient(165deg, \n"
        let textStyle = ''
        colors.forEach((c, i) => {
            style += `${COLORS[c]} ${i * 100 / colors.length}%,\n`
            style += `${COLORS[c]} ${(i + 1) * 100 / colors.length}%,\n`
        })
        style = style.slice(0, -2) + ');'
        if (colors.includes('black') || colors.includes('black_bottom')) {
            textStyle += 'style="color:white; mix-blend-mode: difference;"';
        }

        return [style, textStyle]
    }


    render_plusButton = (railNumber, scale) => {
        let tmp = 0.99
        scale == 2 ? tmp = 1.1 : ""
        scale == 1 ? tmp = 0.95 : ""
        return `<div class='addModuleButton' data-rail=${railNumber} style="margin-top: ${132 / (tmp * scale)}px"><button   data-rail=${railNumber} class="plus-button shadow"></button></div>`
    }

    render_sticker_settings = (config) => {
        const rand = Math.ceil(Math.random() * 10000);
        return `<div class=stickerSettings>
        <div style="padding-right:36px;">
            <div id="sliderStickerHeight">
                <div style="margin-bottom:8px;">${I18N.t('stickerSettings.stickerHeight')} <span id="stickerHeight"></span>мм</div>
                <input id="stickerHeightSlider" type="text" data-slider-ticks="[5,  20,  40, 60, 75]"
                    data-slider-ticks-snap-bounds="0"
                    data-slider-ticks-labels='["5","20","40", "60","75"]' data-slider-value="${config.stickerHeight}"
                    data-slider-min="5" data-slider-max="75" data-slider-step="1"
                    data-slider-tooltip="show" data-slider-tooltip-position="top"
                    style="width:200px;" />
            </div>
            <div id="sliderIconsScale" style="margin-top:15px;">
                <div style="margin-bottom:8px;">${I18N.t('stickerSettings.iconsScale')} <span id="iconsScale"></span>%</div>
                <input id="iconsScaleSlider" type="text" data-slider-ticks="[40, 100, 150, 200]"
                    data-slider-ticks-snap-bounds="0"
                    data-slider-ticks-labels='["40%","100%","150%","200%"]' data-slider-value="${config.iconsScale}"
                    data-slider-min="40" data-slider-max="200" data-slider-step="5"
                    data-slider-tooltip="show" data-slider-tooltip-position="top"
                    style="width:200px;" />
            </div>
            <div id="sliderFontSize" style="margin-top:15px;">
                <div style="margin-bottom:8px;">${I18N.t('stickerSettings.fontSize')} <span id="fontSize"></span></div>
                <input id="fontSizeSlider" type="text" data-slider-ticks="[5, 10, 15, 20]"
                    data-slider-ticks-snap-bounds="0"
                    data-slider-ticks-labels='[5, 10, 15, 20]' data-slider-value="${config.fontSize}"
                    data-slider-min="5" data-slider-max="20" data-slider-step="1"
                    data-slider-tooltip="show" data-slider-tooltip-position="top"
                    style="width:200px;" />

                    <div id="fontsSelector">
                        ${this.getFontsSettings(config)}
                    </div> 
            </div>
        </div>
        <div id="settingsStickersCheckboxes">
            <div class="form-check form-switch" class="stikerSettings">
                <input class="form-check-input" data-setting="stickerNumberTop" type="checkbox"
                    id="numberTopSwitch${rand}" ${config.stickerNumberTop ? "checked" : ""}>
                <label class="form-check-label" for="numberTopSwitch${rand}">${I18N.t('stickerSettings.showTopLabel')}</label>
            </div>
            <div class="form-check form-switch" class="stikerSettings">
            <input class="form-check-input" data-setting="stickerNumberBottom" type="checkbox"
                id="numberBottomSwitch${rand}" ${config.stickerNumberBottom ? "checked" : ""}>
            <label class="form-check-label" for="numberBottomSwitch${rand}">${I18N.t('stickerSettings.showBottomLabel')}</label>
        </div>
            <div class="form-check form-switch">
                <input class="form-check-input" data-setting="stickerIcon" type="checkbox"
                    id="iconSwitch${rand}"  ${config.stickerIcon ? "checked" : ""}>
                <label class="form-check-label" for="iconSwitch${rand}">${I18N.t('stickerSettings.showIcon')}</label>
            </div>
            <div class="form-check form-switch">
                <input class="form-check-input" data-setting="stickerText" type="checkbox"
                    id="textSwitch${rand}"  ${config.stickerText ? "checked" : ""}>
                <label class="form-check-label" for="textSwitch${rand}">${I18N.t('stickerSettings.showText')}</label>
            </div>
            <div class="form-check form-switch">
                <input class="form-check-input" data-setting="stickerVerticalText" type="checkbox"
                    id="verticalTextSwitch${rand}"  ${config.stickerVerticalText ? "checked" : ""}>
                <label class="form-check-label" for="verticalTextSwitch${rand}">${I18N.t('stickerSettings.verticalText')}</label>
            </div>
            <div style="margin-top:10px;">
                <div class="formLabel">${I18N.t('stickerSettings.textAlign')}</div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="textAlignSelector"
                        id="textAlignLeft${rand}" value="left" ${config.stickerTextAlign === 'left' ? 'checked' : ''}>
                    <label class="form-check-label" for="textAlignLeft${rand}">${I18N.t('stickerSettings.alignLeft')}</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="textAlignSelector"
                        id="textAlignCenter${rand}" value="center" ${config.stickerTextAlign !== 'left' && config.stickerTextAlign !== 'right' ? 'checked' : ''}>
                    <label class="form-check-label" for="textAlignCenter${rand}">${I18N.t('stickerSettings.alignCenter')}</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="textAlignSelector"
                        id="textAlignRight${rand}" value="right" ${config.stickerTextAlign === 'right' ? 'checked' : ''}>
                    <label class="form-check-label" for="textAlignRight${rand}">${I18N.t('stickerSettings.alignRight')}</label>
                </div>
            </div>
            <div class="form-check form-switch">
                <input class="form-check-input" data-setting="stickerInvert" type="checkbox"
                    id="invertSwitch${rand}"  ${config.stickerInvert ? "checked" : ""}>
                    <label class="form-check-label" for="invertSwitch${rand}">${I18N.t('stickerSettings.invertOrder')}</label>
            </div>           
            <div style="margin-left:42px;margin-top:25px">
                <div>${I18N.t('stickerSettings.stickerBgColor')}</div>
                <div class="micro_color">color picker</div>
            </div>
        </div>
        <div id="stickerPreview"></div>    
          
        <hr>
    </div>    
    `
    }

    getFontsSettings = (config) => {
        if (!config.fontFamily) {
            config.fontFamily = 'font1'
        }
        const fonts = [
            {
                name: 'rd1.io',
                id: 'font1'
            },
            {
                name: 'Times New Roman',
                id: 'font2'
            },
            {
                name: 'Courier New',
                id: 'font3'
            },
            {
                name: 'Arial',
                id: 'font4'
            },
        ]

        const rand = Math.ceil(Math.random() * 10000);
        let res = ''
        let i = 1;
        const fontLabel = I18N.t('stickerSettings.fontSize').replace(/[:：]\s*$/, '');
        fonts.forEach(font => {
            res += `<div class="form-check ${font.id}">
            <input class="form-check-input" type="radio" value="${font.id}" name="fontSelector" id="${font.id}${rand}" ${config.fontFamily === font.id ? 'checked' : ''}>
            <label class="form-check-label" for="${font.id}${rand}">
             ${fontLabel} ${i}: ${font.name}
            </label>
          </div>`
            i++;
        })

        return res;
    }

    getStickerHeight = (railNumber) => {
        const generalHeight = STORAGE.settings[`stickerHeight${railNumber}`] ? STORAGE.settings[`stickerHeight${railNumber}`] : STORAGE.settings[`stickerHeight`]
        let maxDeviceHeight = 0;
        STORAGE.getDevices().forEach(device => {
            if (device.rail != railNumber) {
                return;
            }
            if (STORAGE.settings[`stickerHeight${device.id}`] > maxDeviceHeight) {
                maxDeviceHeight = STORAGE.settings[`stickerHeight${device.id}`];
            }
        })
        return generalHeight > maxDeviceHeight ? generalHeight : maxDeviceHeight;
    }

    getRailHeight = (railNumber) => {
        const defaultHeight = 100;
        const stickerHeight = this.getStickerHeight(railNumber);
        return parseInt(defaultHeight + stickerHeight);
    }

    render_rail = (railNumber, scale) => {
        const stickerHeight = this.getStickerHeight(railNumber);
        const height = this.getRailHeight(railNumber);
        let tmp = 0.99
        scale == 2 ? tmp = 1.1 : ""

        const stickersOnTop = STORAGE.getSetting('stickersOnTop');
        const handle = `<div class="dinHandle align-middle" style="margin-top: ${140 / (tmp * scale)}px" data-toggle="tooltip" data-placement="top" aria-label=${I18N.t('common.moveRail')} data-bs-original-title=${I18N.t('common.moveRail')}>&#8597;</div>`
        const settings = `<div data-rail=${railNumber} class="dinSettings" style="margin-top: ${140 / (tmp * scale)}px" data-toggle="tooltip" data-placement="top" aria-label=${I18N.t('common.railSettings')} data-bs-original-title=${I18N.t('common.railSettings')}></div>`
        return `<div class="din" style="height: ${height / scale}mm; ${stickersOnTop ? 'background-position-y: ' + (18 + stickerHeight) / scale + 'mm' : ''}" data-rail="${railNumber}"><div class="railNumber">${railNumber + 1}.</div>${this.render_plusButton(railNumber, scale)}<div data-rail=${railNumber} class="dinDevices" data-railHeight=${height}>${handle}${settings}</div></div>`;
    }

    render_scale = (parentId, callback, defaultValue = false) => {
        let res = ` <span id="scale" class="topBoxControls">
        
        <select id="scaleSelect" name="scale" aria-controls="scale"
        class="custom-select custom-select-sm form-control form-control-sm">`;

        [100, 90, 75, 50].forEach(scale => {
            res += `<option value="${100 / scale}">${scale} %</option>`
        })
        res += `</select>
        </span>`
        $(`#${parentId}`).html(res)

        if (defaultValue) {

            $(`#${parentId} #scaleSelect`).val(defaultValue)
        }

        if (callback) {
            $(`#${parentId} #scaleSelect`).on('change', (event) => {
                callback($(event.currentTarget).val())
            })
        }
    }

    render_marker = (portId, x, y, text) => {
        const diff = 22;
        if (portId.includes('_t')) {
            y = y - diff
        }
        else {
            y = y + diff - 7
        }
        // x = x - diff
        return `<div id="marker_${portId}" data-id="${portId}" class="colorMarker yellow" style="left: ${x}px; top: ${y}px;">${text}</div>`
    }

    render_moduleWidthSlider = (mods = 10, renderTexts = true) => {
        const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
        const widthInMM = [];
        const texts = [];
        texts.push(`"1 мод"`);
        for (let i = 2; i <= mods; i++) {
            widthInMM.push(baseWidth * i);
            texts.push(`"${i} мод "`);
        }
        return `<input id="slider" type="text"
data-slider-ticks="[3, ${baseWidth}, ${widthInMM}]"
data-slider-ticks-snap-bounds="1"
${renderTexts ? `data-slider-ticks-labels='["3мм", ${texts}]'` : ""}
data-slider-value="${baseWidth}" data-slider-min="3" data-slider-max="${baseWidth * 10}"
data-slider-step="0.5" data-slider-tooltip="show"
data-slider-tooltip-position="bottom" style="width:860px;" />`
    }

    render_portsSlider = (width, val = 0, sliderWidth = 385) => {
        const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
        const portsCount = Math.ceil(width / baseWidth * SIZE.maxPortsPerMod)

        let portsCountArray = [];
        for (let i = 0; i <= portsCount; i++) {
            portsCountArray.push(i);
        }

        return `<input id="portsSlider" type="text"
        data-slider-ticks="[${portsCountArray.join(", ")}]"
        data-slider-ticks-snap-bounds="1"
        ata-slider-ticks-labels='[0, 1,2]'
        data-slider-value="${val}" data-slider-min="0" data-slider-max="${portsCount}"
        data-slider-step="1" 
        style="width:${sliderWidth}px;" data-slider-tooltip="hide"
        />`
    }

    render_moduleHeightSlider = () => {
        return `<input id="moduleHeightSlider" type="text" data-slider-ticks='["40", "50","75", "100"]'' data-slider-ticks-snap-bounds="0"
            data-slider-ticks-labels=' ["40%", "50%", "75%" , "100%" ]' data-slider-value="100"
            data-slider-min="40" data-slider-max="100" data-slider-step="1"
            data-slider-tooltip="hide" style="width:280px;" />`
    }

    render_danger = (id, scale, twisted = false, display = false) => {

        return `<div class="danger" data-id=${id} data-toggle="tooltip" data-placement="top" title=${I18N.t('common.deviceOutOfRail')} style="width: ${40 / scale}px; height:  ${40 / scale}px; ${twisted ? `transform:rotate(${twisted}deg);transform-origin: center top;` : ""} ${display ? "display: block;" : ""}"></div>`;
    }

    render_din_rail_width_slider = () => {
        const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
        let widths = [];
        let ticks = [];
        for (let i = 0; i <= 60;) {
            i = i + 4;
            widths.push(baseWidth * i)
            ticks.push(`"${i} мод"`)
        }
        return `<input id="dinRailWidthSlider" type="text"
        data-provide="slider"
        data-slider-ticks="[${widths.join(",")}]"
        data-slider-ticks-snap-bounds="1"
        data-slider-ticks-labels='[${ticks.join(",")}]'        
        data-slider-value="356" data-slider-min="105" data-slider-max="595" data-slider-step="1"        
        style="width:955px;" 
        />`
    }

    render_base_width_slider = (id = "baseWidthSlider") => {
        return `<input id="${id}" type="text"
        data-provide="slider"
        data-slider-ticks="[17,19]"
        data-slider-ticks-labels='["17мм","19мм"]'
        data-slider-ticks-snap-bounds="0"       
        data-slider-value="${STORAGE.getSetting('baseWidth', BASE_WIDTH)}" data-slider-min="17" data-slider-max="19" data-slider-step="0.1"
        data-slider-tooltip="show" data-slider-tooltip-position="bottom"
         data-slider-tooltip="hide"
        style="width:300px;" />`
    }

    render_bus_space_slider = (id = "busSpaceSlider") => {
        return `<input id="${id}" type="text" 
        data-provide="slider"
        data-slider-ticks='[0,200]'
        data-slider-ticks-labels='["0мм","200мм"]'
        data-slider-ticks-snap-bounds="0"    
        data-slider-value="${STORAGE.getSetting('busSpace', DEFAULT_BUS_SPACE)}" data-slider-min="0" data-slider-max="200" data-slider-step="1"
        data-slider-tooltip="show" data-slider-tooltip-position="bottom"
         data-slider-tooltip="hide"
        style="width:300px;" />`
    }

    render_label_settings = (title, bottom = false, val = false) => {
        return `
    <div class="formLabel form-switch labelSettings"> 
        <input class="form-check-input" type="checkbox" id="label${bottom ? 'Bottom' : 'Top'}"  ${val ? 'checked' : ''}/>
        <label class="form-check-label" for="label${bottom ? 'Bottom' : 'Top'}">${title}</label>
    </div>
    <div class="row  ${val ? '' : 'hidden'}"  id="labelSettings${bottom ? 'Bottom' : 'Top'}">
        <div class="col-sm">
            <div class="formLabel">${I18N.t('stickerSettings.labelColor')} ${bottom ? I18N.t('stickerSettings.bottom') : I18N.t('stickerSettings.top')}</div>
            <ul class="colours-selector">
                <li data-bottom="${bottom ? 1 : 0}"  class="color red" data-val="red${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color orange" data-val="orange${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color yellow" data-val="yellow${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color green" data-val="green${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color turquoise" data-val="turquoise${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color blue" data-val="blue${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color purple" data-val="purple${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color pink" data-val="pink${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color brown" data-val="brown${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color grey" data-val="grey${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color black" data-val="black${bottom ? '_bottom' : ''}"></li>
                <li data-bottom="${bottom ? 1 : 0}"  class="color white" data-val="white${bottom ? '_bottom' : ''}"></li>
            </ul>
        </div>
        <div class="col-sm">
            <div class="form-group">
                <div class="formLabel">${I18N.t('stickerSettings.labelText')} ${bottom ? I18N.t('stickerSettings.bottom') : I18N.t('stickerSettings.top')}</div>
                <textarea type="text" class="form-control device-number" data-bottom="${bottom ? 1 : 0}"></textarea>
            </div>
        </div>
    </div>`
    }

    render_icon_settings = (val) => {


        return ` <div class="">
        <div class="formLabel form-switch labelSettings">
            <input class="form-check-input" type="checkbox" id="showIcon"
                data-gtm-form-interact-field-id="0" ${val ? 'checked' : ''}>
            <label class="form-check-label" for="showIcon">${I18N.t('stickerSettings.showIcon')}</label>
        </div>
        <div class="icon-selector ${val ? '' : 'hidden'}">
            <div id="iconsSelector"></div>
        </div>
    </div>`
    }

    render_text_settings = (val) => {
        return ` <div class="">
        <div class="formLabel form-switch labelSettings">
            <input class="form-check-input" type="checkbox" id="showText"
                data-gtm-form-interact-field-id="0" ${val ? 'checked' : ''}>
            <label class="form-check-label" for="showText">${I18N.t('stickerSettings.showText')}</label>
        </div>
        <div class="form-group text-input ${val ? '' : 'hidden'}">
            <textarea type="text" class="form-control" id="device-name"></textarea>
        </div>

    </div>`
    }
}


